/**
 * Puschies Menü-Drawer V3 (snippets/p-menu-drawer.liquid)
 *
 * Nur das, was Theme nicht mitbringt:
 * - Inline-Akkordeons mit weicher Höhen-Animation (1:1 Hyper menu-drawer-v3)
 * - Länder-/Währungs-Auswahl nach oben aufklappen (Hyper-Disclosure)
 * - ESC schließt zuerst die Länderliste, sonst den ganzen Drawer (statt nur das Akkordeon)
 * Öffnen/Schließen/Slide/Scroll-Lock/Fokus bleiben bei Theme <header-drawer>.
 */
if (!customElements.get('p-menu-drawer')) {
  const DURATION = 250;

  class PMenuDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      this.addEventListener('keyup', this.#onKeyUp);
      document.addEventListener('click', this.#onDocumentClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('keyup', this.#onKeyUp);
      document.removeEventListener('click', this.#onDocumentClick);
    }

    get #localeToggle() {
      return this.querySelector('.p-menu-drawer__locale-toggle');
    }

    /** @param {MouseEvent} event */
    #onClick = (event) => {
      const target = /** @type {Element} */ (event.target);

      const summary = target.closest('.p-menu-drawer__summary');
      if (summary) {
        event.preventDefault();
        this.#toggleAccordion(/** @type {HTMLDetailsElement} */ (summary.parentElement));
        return;
      }

      if (target.closest('.p-menu-drawer__locale-toggle')) {
        this.#setLocaleOpen(this.#localeToggle?.getAttribute('aria-expanded') !== 'true');
      }
    };

    /** @param {MouseEvent} event */
    #onDocumentClick = (event) => {
      if (!(event.target instanceof Element) || event.target.closest('.p-menu-drawer__locale-form')) return;
      this.#setLocaleOpen(false);
    };

    /** @param {KeyboardEvent} event */
    #onKeyUp = (event) => {
      if (event.key !== 'Escape') return;
      event.stopPropagation();

      if (this.#localeToggle?.getAttribute('aria-expanded') === 'true') {
        this.#setLocaleOpen(false);
        this.#localeToggle.focus();
        return;
      }

      const headerDrawer = /** @type {any} */ (this.closest('header-drawer'));
      headerDrawer?.close?.();
    };

    /** @param {boolean} open */
    #setLocaleOpen(open) {
      this.#localeToggle?.setAttribute('aria-expanded', String(open));
    }

    /** @param {HTMLDetailsElement} details */
    #toggleAccordion(details) {
      const panel = details.querySelector(':scope > .p-menu-drawer__panel');
      if (!(panel instanceof HTMLElement)) return;

      panel.style.transition = `height ${DURATION}ms ease`;

      if (details.open) {
        panel.style.height = `${panel.scrollHeight}px`;
        requestAnimationFrame(() => {
          panel.style.height = '0px';
        });
        this.#afterTransition(() => {
          details.open = false;
          panel.style.height = '';
          panel.style.transition = '';
        });
      } else {
        details.open = true;
        panel.style.height = '0px';
        const target = panel.scrollHeight;
        requestAnimationFrame(() => {
          panel.style.height = `${target}px`;
        });
        this.#afterTransition(() => {
          panel.style.height = 'auto';
          panel.style.transition = '';
        });
      }
    }

    /** @param {() => void} callback */
    #afterTransition(callback) {
      window.setTimeout(callback, DURATION + 20);
    }
  }

  customElements.define('p-menu-drawer', PMenuDrawer);
}
